import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import DataTableRepository from "../Repositories/DataTableRepository";

class DataTableBloc {
  rowtableChannel = new Subject();
  inactiveChannel = new Subject();
  createChannel = new Subject();
  checkPeriodChannel = new Subject();
  repository = new DataTableRepository();

  constructor() {
    this.rowtableChannel.next({ status: apiResponse.INITIAL });
    this.inactiveChannel.next({ status: apiResponse.INITIAL });
  }

  fetchRowTable = async (query, cancelToken) => {
    try {
      this.rowtableChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRowTable(query, cancelToken)
        .then((result) => {
          this.rowtableChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.rowtableChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };

  fetchInactive = async (query) => {
    try {
      this.inactiveChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchInactive(query)
        .then((result) => {
          this.inactiveChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.inactiveChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };
  fetchCreate = async (query) => {
    try {
      this.createChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchCreate(query)
        .then((result) => {
          this.createChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.createChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };
  checkPeriodRapelIsFleg = async (query) => {
    try {
      this.checkPeriodChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .checkPeriodRapelIsFleg(query)
        .then((result) => {
          this.checkPeriodChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.checkPeriodChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };
}

export default DataTableBloc;
